<template>
  <div>
    <Cover />
    <Letter />
    <PeninsularIntro />
    <PeninsularTables 
      :selectedItems="selectedItems" 
      @updateTotalPages="handleUpdateTotalPages" 
    />
    <InsularIntro v-show="isCannarySelected" />
    <InsularTables @updateTotalPages="handleUpdateTotalPages" />
    <CargaIntro v-show="isCargaSelected" />
    <CargaTables v-show="isCargaSelected" @updateTotalPages="handleUpdateTotalPages" />
    <AdditionalServices />
    <!-- <OtherConsiderations /> -->
    <!-- <Aduaneros v-show="isCannarySelected" /> -->
    <InternationalIntro v-show="isInternationalSelected" />
    <InternationalTables
      v-show="isInternationalSelected"
      @updateTotalPages="handleUpdateTotalPages"
    />
    <AdditionalServicesInternational v-show="isInternationalSelected" />
    <ServicesAgreement @updateTotalPages="handleUpdateTotalPages" />
    <ContractText />
    <!-- <Sepa v-if="isPaymentDebit" /> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import { DEBIT_PAYMENT_METHODS } from '@/helpers/constants'
import { getSectionPreviousPages } from '@/containers/offer-form/sign-off/getSectionPreviousPages'
import Cover from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/Cover'
import Letter from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/Letter'
import PeninsularIntro from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/PeninsularIntro'
import PeninsularTables from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/PeninsularTables'
import InsularIntro from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/InsularIntro'
import InsularTables from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/InsularTables'
import CargaIntro from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/CargaIntro'
import CargaTables from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/CargaTables'
import AdditionalServices from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/AdditionalServices'
// import OtherConsiderations from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/OtherConsiderations'
// import Aduaneros from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/Aduaneros'
import InternationalIntro from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/InternationalIntro'
import InternationalTables from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/InternationalTables'
import AdditionalServicesInternational from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/AdditionalServicesInternational'
import ServicesAgreement from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/ServicesAgreement'
import ContractText from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/ContractText'
// import Sepa from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/Sepa'
import '@/styles/pdf-vd2024.scss'

const CARGA_PRODUCTS = ['TARIFF_STANDARD_CCAR_PT']

const ISLANDS_PRODUCTS = [
  'TARIFF_STANDARD_PTM',
  'TARIFF_STANDARD_PTE',
  'TARIFF_STANDARD_PTE_ACORES',
  'TARIFF_STANDARD_PTE_MADEIRA',
  'TARIFF_STANDARD_BALMARITIMO',
  'TARIFF_STANDARD_BALEXPRESS',
  'TARIFF_STANDARD_PTI',
  'TARIFF_STANDARD_CANEXPRESS',
  'TARIFF_STANDARD_OTHERDESTINATIONS',
]

const INTERNATIONAL_PRODUCTS = ['JSON_INTEXP', 'JSON_INTSTD', 'JSON_INT_ECOMMERCE']

export default {
  name: 'PdfVentaDirecta2026PtNexus',
  components: {
    Cover,
    Letter,
    PeninsularIntro,
    PeninsularTables,
    InsularIntro,
    InsularTables,
    CargaIntro,
    CargaTables,
    AdditionalServices,
    // OtherConsiderations,
    // Aduaneros,
    InternationalIntro,
    InternationalTables,
    AdditionalServicesInternational,
    ServicesAgreement,
    ContractText,
    // Sepa,
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    ...mapState('process', ['pdfPagesPerSection']),
    getProductList() {
      return this[GET_OFFER_ITEM]('productList')
    },
    additionalServices() {
      return this[GET_OFFER_ITEM]('extraServicesList')
    },
    paymentMethods() {
      return this[GET_OFFER_ITEM]('paymentMethods')
    },
    isPaymentDebit() {
      const selectedPaymentMethod = this.paymentMethods.find(method => method.isSelected)?.id
      return DEBIT_PAYMENT_METHODS.includes(selectedPaymentMethod)
    },
    sectionsPages() {
      return {
        Cover: 1,
        Letter: 1,
        PeninsularIntro: 1,
        PeninsularTables: 1,
        InsularIntro: 1,
        InsularTables: 1,
        CargaIntro: 1,
        CargaTables: 1,
        AdditionalServices: 1,
        OtherConsiderations: 0,
        Aduaneros: 0,
        InternationalIntro: 1,
        InternationalTables: 1,
        AdditionalServicesInternational: 0,
        ServicesAgreement: 1,
        ContractText: 10,
        Sepa: this.isPaymentDebit ? 1 : 0,
      }
    },
    selectedItems() {
      // Devuelve la lista de todos los productos obligatorios + los que han sido seleccionados en el paso anterior.
      return this.getProductList?.filter(el => el.isSelected || el.isPreSelected || el.isMandatory)
    },
    islands() {
      return this.selectedItems?.filter(el => ISLANDS_PRODUCTS.includes(el.desc_key)) 
    },
    isCannarySelected() {
      return this.islands?.length !== 0
    },
    international() {
      return this.selectedItems?.filter(el => INTERNATIONAL_PRODUCTS.includes(el.desc_key))
    },
    isInternationalSelected() {
      return this.international?.length !== 0
    },
    carga() {
      return this.selectedItems?.filter(el => CARGA_PRODUCTS.includes(el.desc_key))
    },
    isCargaSelected() {
      return this.carga?.length !== 0
    },
  },
  methods: {
    ...mapMutations('process', ['setPdfSectionPages']),
    handleUpdateTotalPages(sectionPages) {
      this.setPdfSectionPages(sectionPages)
    },
    formatNumber(num, decimals = 2) {
      return parseFloat(num)
        .toFixed(decimals)
        .replace('.', ',')
        .replace(/,0+$/, '')
    },
    additionalServiceData(service) {
      return {
        value: this.formatNumber(service.value),
        minValue: this.formatNumber(service.minValue),
      }
    },
    getAdditionalServiceByField(field, value) {
      if (!this.additionalServices) return {}
      const service = this.additionalServices.find(element => element[field] === value)
      return service ? this.additionalServiceData(service) : {}
    },
    getAdditionalServiceById(id) {
      return this.getAdditionalServiceByField('id', id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.getAdditionalServiceByField('desc_key', desc)
    },
    sectionPreviousPages(section) {
      const sections = [
        'Cover',
        'Letter',
        'PeninsularIntro',
        'PeninsularTables',
        'InsularIntro',
        'InsularTables',
        'CargaIntro',
        'CargaTables',
        'AdditionalServices',
        'OtherConsiderations',
        'Aduaneros',
        'InternationalIntro',
        'InternationalTables',
        'AdditionalServicesInternational',
        'ServicesAgreement',
        'ContractText',
        'Sepa',
      ]
      const previousSections = sections.slice(0, sections.indexOf(section))
      return getSectionPreviousPages(this.pdfPagesPerSection, previousSections)
    },
  },
  created() {
    this.setPdfSectionPages(this.sectionsPages)
  },
}
</script>
